import * as React from "react"

export default function CancelCircleIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16.001A8 8 0 0012 20zM8.523 7.109l8.368 8.368a6.041 6.041 0 01-1.414 1.414L7.109 8.523A6.04 6.04 0 018.523 7.11v-.001z"
        fill={props.fill}
      />
    </svg>
  )
}